import { render, staticRenderFns } from "./proposalHistory.vue?vue&type=template&id=659bcc00&scoped=true"
import script from "./proposalHistory.vue?vue&type=script&lang=js"
export * from "./proposalHistory.vue?vue&type=script&lang=js"
import style0 from "./proposalHistory.vue?vue&type=style&index=0&id=659bcc00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659bcc00",
  null
  
)

export default component.exports